import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';

import { getSearchIndex } from '@/service/algolia';


export default /*#__PURE__*/_defineComponent({
  __name: 'EzCareToggle',
  props: {
    jobSiteId: null,
    value: null
  },
  emits: ['input'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  jobSiteId?: string;
  value?: {
    projectId: string;
    projectCode?: string;
    projectName?: string;
  };
}




const ezCareEnabled = ref<boolean>(false);
const showError = ref<boolean>(false);
const loading = ref<boolean>(false);
const searching = ref<boolean>(false);
const noProjectsFound = ref<boolean>(false);
const searchQuery = ref<string>('');
const projectResults = ref<{ objectID: string; code: string; name: string; display: string }[]>([]);

let debounceTimer: ReturnType<typeof setTimeout> | null = null;

onMounted(async () => {
  if (!props.value?.projectId) return;
  ezCareEnabled.value = true;
  searchQuery.value = [props.value.projectCode, props.value.projectName].filter(Boolean).join(' - ');
  await searchProjects('');
});

watch(() => props.jobSiteId, clearValues);

watch([ezCareEnabled, () => props.jobSiteId], async () => {
  if (!ezCareEnabled.value) {
    clearValues();
    return;
  }
  if (!props.jobSiteId) {
    showError.value = true;
    return;
  }
  showError.value = false;
  noProjectsFound.value = false;
  loading.value = true;
  await searchProjects('');
  loading.value = false;
});

function clearValues() {
  searchQuery.value = '';
  projectResults.value = [];
  noProjectsFound.value = false;
  emitUpdate(null);
}

function onFocus() {
  if (!projectResults.value.length) searchProjects('');
}

function onSearch(query: string) {
  if (debounceTimer) clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => searchProjects(query), 300);
}

async function searchProjects(query: string) {
  if (!props.jobSiteId || !ezCareEnabled.value) return;
  searching.value = true;
  try {
    const index = getSearchIndex('projects');
    const result = await index.search(query, {
      filters: `jobSite.id:${props.jobSiteId} AND deleted:false`,
      hitsPerPage: 20,
    });
    projectResults.value = result.hits.map((hit: any) => ({
      objectID: hit.objectID,
      code: hit.code,
      name: hit.name,
      display: `${hit.code} - ${hit.name}`,
    }));
    noProjectsFound.value = result.hits.length === 0 && query === '';
  } catch {
    projectResults.value = [];
  } finally {
    searching.value = false;
  }
}

function onProjectSelect(option: { objectID: string; code: string; name: string } | null) {
  if (!option) {
    emitUpdate(null);
    return;
  }
  emitUpdate({
    projectId: option.objectID,
    projectCode: option.code,
    projectName: option.name,
  });
}

function emitUpdate(value: { projectId: string; projectCode?: string; projectName?: string } | null) {
  emit('input', value);
}

expose({ ezCareEnabled, searchQuery, onProjectSelect });

return { __sfc: true,props, emit, ezCareEnabled, showError, loading, searching, noProjectsFound, searchQuery, projectResults, debounceTimer, clearValues, onFocus, onSearch, searchProjects, onProjectSelect, emitUpdate }
}

})